module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vid-area"
  }, [_c('div', {
    staticStyle: {
      "left": "0",
      "width": "100%",
      "height": "0",
      "position": "relative",
      "padding-bottom": "56.2493%"
    }
  }, [_c('iframe', {
    staticStyle: {
      "border": "0",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%",
      "position": "absolute"
    },
    attrs: {
      "src": _vm.videoLink,
      "allowfullscreen": "",
      "scrolling": "no"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-634adbc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vids.vue
// module id = 309
// module chunks = 1